import ResourceService from "./resource.service";
import Vue from "vue";

class EnumeratesService extends ResourceService {
  static get resource() {
    return "enumerates";
  }

  static countries(params) {
    const url = `${this.resource}/countries`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static currencies(params) {
    const url = `${this.resource}/currencies`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static genders(params) {
    const url = `${this.resource}/genders`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static nationalities(params) {
    const url = `${this.resource}/nationalities`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static roles(params) {
    const url = `roles`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default EnumeratesService;
